import { useParseRouteActions } from "../../../helpers/GlobalHelper";
import LmsTable from "../ui/LmsTable";

const AbDataAtSaleTable = () => {
  const actionsButtons = ["export"];
  return <LmsTable
    actionButtons={actionsButtons}
    apiSuffix="report/ab-data-at-sale"
    columnLabelsDictionary={{
      loanNumber: "Loan #",
      apiece: "A Piece",
      bpiece: "B Piece",
      notionalBpiece: "Notional B Piece",
      Pqpayments: "PQ Payments",
      nbcp: "Notional Per"
    }}
    dataRules={[
      { rule: "format", display: "percent", field: "nbcp" }
    ]}
    skipClick
  />;
};

const LmsReportsAbDataAtSale = ({ params = {}, history }) => {
  const { isActionAllowed } = useParseRouteActions(params);
  if (!isActionAllowed) {
    history.goBack();
  }
  return ( <AbDataAtSaleTable /> );
};

export default LmsReportsAbDataAtSale;